import { render } from "./PostPreview.vue?vue&type=template&id=194d0a35"
import script from "./PostPreview.vue?vue&type=script&lang=js"
export * from "./PostPreview.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__